import { createStyles } from "@mantine/core";

export const usePageStyles = createStyles((theme) => {
    return {
        wrapper: {
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
        },
        head: {

        },
        body: {
            flex: 1,
            overflowY: 'auto',
            display: 'flex',
            flexDirection: 'column',
            boxSizing: 'border-box',
        },
        footer: {
            borderTop: `1px solid ${theme.colors.gray[3]}`,
            marginTop: '1rem'
        }
    }
})